<template>
  <div class="ts-p-3">
    <h6
      class="ts-text-white ts-uppercase ts-bg-blue-500 ts-px-2 ts-py-1 ts-rounded-md"
      style="width:fit-content"
    >{{ $t('promotion.productItem') }}</h6>
    <ts-checkbox
      class="ts-font-light"
      v-model="model.is_apply_all_product"
      @change="() => model.pro_sale_code_id_list = []"
    >{{ $t('promotion.applyForAllProduct') }}</ts-checkbox>
    <div class="ts-overflow-auto ts-mt-2" style="max-height:40vh">
      <table class="ts-w-full ts-mt-4">
        <thead>
          <tr>
            <th class="ts-w-1/2">{{ $t('promotion.product') }}</th>
            <th>{{ $t('promotion.quantity') }}</th>
            <th width="9%">{{ $t('promotion.guestLevel') }}</th>
            <th width="9%">{{ $t('promotion.discountType') }}</th>
            <th width="9%">{{ $t('promotion.discountRate') }}</th>
            <th class="ts-w-1">
              <a href="#" @click.prevent="() => show_form = true" v-if="!model.is_apply_all_product">
                <i class="fa fa-plus"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(pro, index) in model.pro_sale_code_id_list" :key="index">
            <td valign="middle">
              <p class="ts-mb-0">{{ getProductName(pro.pro_sale_code_id) }}</p>
              <div
                class="validate ts-text-xs"
                v-if="errors.has('pro_sale_code_id_list.' + index + '.pro_sale_code_id')"
              >{{ errors.first('pro_sale_code_id_list.' + index + '.pro_sale_code_id') }}</div>
            </td>
            <td>
              <input
                v-model.number="pro.quantity"
                type="number"
                class="ts-w-32 ts-border ts-rounded ts-outline-none ts-px-2"
              />
              <div
                class="validate ts-text-xs"
                v-if="errors.has('pro_sale_code_id_list.' + index + '.quantity')"
              >{{ errors.first('pro_sale_code_id_list.' + index + '.quantity') }}</div>
            </td>
            <td>
              <a-select v-model="pro.guest_level_id" :options="guestLevels" show-search option-filter-prop="children"
              class="ts-w-full" :class="{ 'is-invalid': errors.has('guest_level_id') }" placeholder="Select"
              disabled></a-select>
            </td>
            <td>
              <a-select
                v-model="pro.discount_type"
                class="ts-w-full"
                style="min-width: 50px"
              >
                <a-select-option value="%">%</a-select-option>
                <a-select-option
                  :value="default_currency_sign"
                >
                  {{ default_currency_sign }}
                </a-select-option>
              </a-select>
              <div
                class="validate ts-text-xs"
                v-if="errors.has('pro_sale_code_id_list.' + index + '.discount_type')"
              >
                {{ errors.first('pro_sale_code_id_list.' + index + '.discount_type') }}
              </div>
            </td>
            <td>
              <InputNumber
                v-if="pro.discount_type === '%'"
                :max="100"
                v-model="pro.discount_rate"
                :formatter="value => `${value}%`"
                :parser="value => value.replace('%', '')"
                style="width: 100%"
            ></InputNumber>
              <input
                v-else
                ref="discountRate"
                type="number"
                v-model.number="pro.discount_rate"
                class="form-control"
              />
              <div
                class="validate ts-text-xs"
                v-if="errors.has('pro_sale_code_id_list.' + index + '.discount_rate')"
              >
                {{ errors.first('pro_sale_code_id_list.' + index + '.discount_rate') }}
              </div>
            </td>
            <td>
              <a
                href="#"
                class="ts-text-red-700 hover:ts-text-red-700"
                @click.prevent="removeItem(index)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- show product list pop-up -->
    <a-modal
      v-if="show_form"
      v-model="show_form"
      :title="$t('promotion.product')"
      :footer="null"
    >
      <ProductList v-model="model" />
    </a-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Errors } from 'form-backend-validation'
import ProductList from './modal-popup/discount-rate-product-list.vue'
export default {
  name: 'productSaleCode',
  props: ['value', 'validate'],
  components: {
    ProductList,
  },
  data() {
    return {
      errors: new Errors(),
      show_form: false,
      model: {},
      guestLevels: [
        { value: 1, label: 'Regular' },
        { value: 2, label: 'VIP' }
      ]
    }
  },
  computed: {
    ...mapGetters('promotion/resource', ['getProductName']),
    default_currency_sign() {
      return this.$store.state.authUser.sys_setting.default_currency_sign
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    removeItem(index) {
      this.model.pro_sale_code_id_list.splice(index, 1)
    },
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style lang="css" scoped>
table > thead > tr > th {
  background: rgb(238, 238, 238);
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
  padding: 2px 7px;
}

table > tbody > tr > td {
  padding: 3px;
  border-bottom: 1px solid rgb(226, 226, 226);
}
</style>